import request from 'then-request';

module.exports.registerEmail = (email,lang,media) => {

    return new Promise((resolve,reject)=>{

        let postDataAll = [
            {
                "lang": "no",
                "update_on_duplicate": false,
                "tags": [
                    "Newsletter NO",
                    "Online registration form NO",
                    "Media_"+media,
                ],
                "subscribers": {
                    "email": email,
                    "language": "no"
                }
            },
            {
                "lang": "se",
                "update_on_duplicate": false,
                "tags": [
                    "Newsletter SE",
                    "Online registration form SE",
                    "Media_"+media,
                ],
                "subscribers": {
                    "email": email,
                    "language": "sv"
                }
            },
        ];

        let filteredPostData = postDataAll.filter(function(data){
           return (data.lang===lang);
        });

        let postData = (filteredPostData.length ? filteredPostData[0] : false);

        if(postData!==false)
        {
            request('POST', 'https://ruleapi.allegro.no/v2/subscribers/',{
                json: postData
            })
            .done((res) => {

                if(res.statusCode===200) {

                    let body = JSON.parse(res.getBody());

                    if(body.error) {

                        console.log("Error: ", body.error, body);
                        reject(body);

                    }
                    else {
                        resolve(body);
                    }
                }
                else {

                    reject(res);

                }
            });

        }
        else reject('No postdata available.');
    });
}


// WEBPACK FOOTER //
// ./src/helpers/register.js